/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: search.fga
 * Run: pnpm run gen:permissions -- search
 */

import type { ModulePermissions } from './types';

export const searchPermissions = {
  module: 'search',
  displayName: 'Search',
  entities: [
    {
      name: 'search',
      displayName: 'Search',
      permissions: [{ key: 'searchRead', action: 'Read', category: 'crud' }],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Search module
 */
export type SearchPermissionKey = 'searchRead';
